/* GSM Reparatie Purmerend - slimme sticky header (desktop) */
(function () {
  var bar = document.querySelector('[data-grp-sticky-bar]');
  var slot = document.querySelector('[data-grp-sticky-slot]');
  if (!bar || !slot) return;

  var desktop = window.matchMedia('(min-width: 990px)');
  var limit = 700;
  var ticking = false;

  function isScroller(el) {
    if (!el) return false;
    var o = getComputedStyle(el).overflowY;
    return (o === 'auto' || o === 'scroll') && el.scrollHeight > el.clientHeight + 1;
  }

  var wrapper = document.querySelector('.page-wrapper');
  var scroller = isScroller(wrapper) ? wrapper : null;

  function getY() {
    return scroller ? scroller.scrollTop : window.scrollY;
  }

  function getMax() {
    return scroller
      ? scroller.scrollHeight - scroller.clientHeight
      : document.documentElement.scrollHeight - window.innerHeight;
  }

  var lastY = getY();

  function calcLimit() {
    var main = document.getElementById('MainContent');
    var first = main && main.querySelector('.shopify-section');
    var end = first ? first.getBoundingClientRect().bottom + getY() - 120 : 0;
    limit = Math.max(700, end);
  }

  function update() {
    ticking = false;
    var y = getY();

    if (!desktop.matches) {
      bar.classList.remove('is-stuck', 'is-hidden');
      lastY = y;
      return;
    }

    var stuck = slot.getBoundingClientRect().top <= 12;
    bar.classList.toggle('is-stuck', stuck);

    var menuOpen = bar.matches(':hover') || bar.contains(document.activeElement);

    if (!stuck || y < limit || menuOpen) {
      bar.classList.remove('is-hidden');
      lastY = y;
    } else if (y - lastY > 8) {
      bar.classList.add('is-hidden');
      lastY = y;
    } else if (lastY - y > 8) {
      bar.classList.remove('is-hidden');
      lastY = y;
    }

    var max = getMax();
    bar.style.setProperty('--grp-scroll', max > 0 ? Math.min(1, y / max).toFixed(4) : 0);
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  (scroller || window).addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    var next = isScroller(wrapper) ? wrapper : null;
    if (next !== scroller) {
      (scroller || window).removeEventListener('scroll', onScroll);
      scroller = next;
      (scroller || window).addEventListener('scroll', onScroll, { passive: true });
    }
    calcLimit();
    update();
  });
  window.addEventListener('load', function () { calcLimit(); update(); });
  calcLimit();
  update();
})();
